const BranchCodeType = Symbol();

export class BranchCode {
    [BranchCodeType]: any;
    readonly value: string;

    private constructor(branchCode: string) {
        this.value = branchCode;
    }

    static fromString(branchCode: string) {
        return new BranchCode(branchCode);
    }
}

